// Signed-in state for the store's navigation.
// Asks the community app whether this browser has a member session (the session cookie is sent because the store
// and the community share a site), then flips the header and bottom bar to the member state and fills in the
// notification count and the Groups unread dot. Anything short of a clear "yes" leaves the visitor state alone.
(() => {
  const header = document.querySelector('.ss-header');
  if (!header) return;
  const base = header.dataset.community;
  if (!base) return;

  const apply = (state) => {
    if (!state || typeof state.signedIn !== 'boolean') return;
    document.documentElement.dataset.ssState = state.signedIn ? 'member' : 'visitor';
    if (!state.signedIn) return;
    const unread = Number(state.unread) || 0;
    document.querySelectorAll('[data-ss-bell-count]').forEach((el) => {
      el.hidden = unread === 0;
      el.textContent = unread > 9 ? '9+' : String(unread);
    });
    document.querySelectorAll('[data-ss-bell]').forEach((el) => {
      el.setAttribute('aria-label', unread ? `Notifications, ${unread} unread` : 'Notifications');
    });
    document.querySelectorAll('[data-ss-groups-dot]').forEach((el) => {
      el.hidden = !state.groupsUnread;
    });
  };

  fetch(`${base}/api/nav-state`, { credentials: 'include', mode: 'cors', cache: 'no-store' })
    .then((r) => (r.ok ? r.json() : null))
    .then(apply)
    .catch(() => {});
})();
